import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

function AdminRoute({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const isAuthenticated = auth.user !== null && auth.user.wallet_address.toLowerCase() === process.env.REACT_APP_COMPOSENFT_SERVICER.toLowerCase();
  let location = useLocation();

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
export default AdminRoute;
